import { config } from "./config";

export const loadEnvironmentVariables = ({
  runtimeConfig,
}: {
  runtimeConfig: Record<string, unknown>;
}) => Object.assign(config, runtimeConfig.public);
